import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_LEAD_STICKY_COLUMNS,
  UPDATE_LEAD_STICKY_COLUMNS,
} from "./actionTypes"

import {
  getLeadStickyColumnsSuccess,
  getLeadStickyColumnsError,
  updateLeadStickyColumnsSuccess,
  updateLeadStickyColumnsError
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* ongetLeadStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_leads`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getLeadStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getLeadStickyColumnsError(error))
  }
}

function* onupdateLeadStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_leads/${action?.payload?.user_column_preference_lead?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateLeadStickyColumnsError(error))
  }
}

function* userLeadColumnPreferenceSaga() {
  yield takeEvery(GET_LEAD_STICKY_COLUMNS, ongetLeadStickyColumns)
  yield takeEvery(UPDATE_LEAD_STICKY_COLUMNS, onupdateLeadStickyColumns)
}

export default userLeadColumnPreferenceSaga;
